var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t \t.bar {transform: scaleX(0); transform-origin: center;}\n\t \t.circle {transform: scale(1); transform-origin: center;}\n\t ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 15,
    cy: 75,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 75,
    cy: 75,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 135,
    cy: 75,
    r: 11
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bar",
    d: "M146,75c0-5.7-4.4-10.4-10-10.9V64H15C8.9,64,4,68.9,4,75s4.9,11,11,11h121v-0.1C141.6,85.4,146,80.7,146,75z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoMore);
export default __webpack_public_path__ + "static/media/picto-more.9a840bd8.svg";
export { ForwardRef as ReactComponent };